import { BlipChat } from 'blip-chat-widget';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import './ChatbotTest.scss';
import { NavbarFeatures } from '../NavbarFeatures';
import { DEBUG_OPENED, DEBUG_REFRESH } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderSegmentEvents';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
const USER_TESTER_KEY = 'userTesterID';
const FLOW_KEY = 'flow';
export class ChatbotTestController {
    static $inject = ['application', 'ApplicationService2', 'SegmentService', 'UsersService', 'close', 'BLIPCHATURI', 'BLIPCHATURITENANT', 'ChatService', '$cookies', 'DEBUG_URL', 'DEBUG_URL_TENANT', '$base64', 'AccountService2', 'AuthenticationService', '$translate', 'ChatbotSettingsService', 'ngToast', 'BLIP_ACCOUNT_ISSUER', 'BLIP_AZURE_ISSUER', 'TenantService', 'typeOfCompile'];
    constructor(application, ApplicationService2, SegmentService, UsersService, close, BLIPCHATURI, BLIPCHATURITENANT, ChatService, $cookies, DEBUG_URL, DEBUG_URL_TENANT, $base64, AccountService2, AuthenticationService, $translate, ChatbotSettingsService, ngToast, BLIP_ACCOUNT_ISSUER, BLIP_AZURE_ISSUER, TenantService, typeOfCompile) {
        'ngInject';
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.SegmentService = SegmentService;
        this.UsersService = UsersService;
        this.close = close;
        this.BLIPCHATURI = BLIPCHATURI;
        this.BLIPCHATURITENANT = BLIPCHATURITENANT;
        this.ChatService = ChatService;
        this.$cookies = $cookies;
        this.DEBUG_URL = DEBUG_URL;
        this.DEBUG_URL_TENANT = DEBUG_URL_TENANT;
        this.$base64 = $base64;
        this.AccountService2 = AccountService2;
        this.AuthenticationService = AuthenticationService;
        this.$translate = $translate;
        this.ChatbotSettingsService = ChatbotSettingsService;
        this.ngToast = ngToast;
        this.BLIP_ACCOUNT_ISSUER = BLIP_ACCOUNT_ISSUER;
        this.BLIP_AZURE_ISSUER = BLIP_AZURE_ISSUER;
        this.TenantService = TenantService;
        this.typeOfCompile = typeOfCompile;
        this.init();
    }
    async init(setNewUser = false) {
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        const account = await this.ApplicationService2.getAccount();
        const botKey = account.extras['blipchat-app-key'] || undefined;
        this.blipChatKey = btoa(`${this.application.shortName}:${botKey}`);
        this.botTesterCookieKey = this.application.shortName + '_' + USER_TESTER_KEY;
        const blipChatUri = this.TenantService.addTenantPrefixToUrl(this.BLIPCHATURITENANT, this.application?.tenantId, this.BLIPCHATURI);
        let userID = this.getUserTesterCookieID();
        const userSource = '0mn.io';
        const userIdentity = userID ? userID + '.' + this.application.shortName + '@' + userSource : undefined;
        const user = userID ? await this.UsersService.getUser(this.application, userIdentity) : undefined;
        if (userID === undefined || setNewUser || user.extras.typeOfCompile !== this.typeOfCompile) {
            userID = uuid();
            this.saveUserTesterCookie(userID);
            await this.setUserAsTester(userID);
        }
        if (this.typeOfCompile === FLOW_KEY) {
            this.shouldShowDebugButton = true;
            this.testBotTitle = await this.$translate('modules.application.detail.testTitle');
        }
        else {
            this.shouldShowDebugButton = false;
            this.testBotTitle = await this.$translate('modules.application.detail.testTitleBucket');
        }
        try {
            this.blipChatWidget = new BlipChat()
                .withAppKey(this.blipChatKey)
                .withButton({ 'color': '#2CC3D5' })
                .withTarget('chat-container')
                .withCustomCommonUrl(blipChatUri)
                .withAuth({
                authType: BlipChat.DEV_AUTH,
                userIdentity: userID,
                userPassword: 'teste123',
            });
            this.blipChatWidget.build();
            this.triggerTrackings();
            this.isBuilderActive = await this.ChatbotSettingsService.isBuilderActive(this.application);
        }
        catch (e) {
            console.error(e);
        }
    }
    triggerTrackings() {
        this.SegmentService.createTrack('test-chatbot', {
            botName: this.application.name,
            template: this.application.template,
            status: this.application.status,
            typeEvent: this.typeOfCompile === FLOW_KEY ? 'Published' : 'Autosaved',
            screen: window.location.pathname,
        });
    }
    async setUserAsTester(userID) {
        const userSource = '0mn.io';
        const userIdentity = userID + '.' + this.application.shortName + '@' + userSource;
        const dateTime = moment().format('DD-MM-YY HH:mm:ss');
        const user = {
            identity: userIdentity,
            name: 'Tester ' + dateTime,
            group: 'Testers',
            source: userSource,
            extras: { isTestersGroup: true, typeOfCompile: this.typeOfCompile },
        };
        try {
            await this.UsersService.setUser(user);
        }
        catch (e) {
            console.error(e);
        }
    }
    async closeSidebar() {
        try {
            this.blipChatWidget.destroy();
            this.blipChatWidget = undefined;
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
    async openDebug() {
        if ((this.application.template !== 'builder' || !this.isBuilderActive) &&
            !await NavbarFeatures.isChatbotSdkDebuggerEnabled()) {
            const debugLimitationInfo = await this.$translate('navbar.debugLimitationInfo');
            this.ngToast.info(debugLimitationInfo);
            return;
        }
        const accessKey = this.application.accessKey;
        const identifier = this.application.shortName;
        const blipIdentifier = encodeURIComponent(this.AuthenticationService.email);
        const blipToken = this.AuthenticationService.token;
        const me = await this.AccountService2.me();
        const storageOidcData = JSON.parse(localStorage.getItem('oidc.azureB2CData'));
        const azureAdEnabled = !!storageOidcData && !!storageOidcData.isEnabled;
        const issuer = azureAdEnabled ? this.BLIP_AZURE_ISSUER : this.BLIP_ACCOUNT_ISSUER;
        const email = encodeURIComponent(me.email);
        const fullName = encodeURIComponent(me.fullName);
        const tenantId = this.application?.tenantId || '';
        const useCommandWithDelegation = await MessagingHubFeatures.GetUserMessagingHubCommandWithDelegation();
        const msgAccesskey = useCommandWithDelegation ? '' : `msg-accesskey=${accessKey}&`;
        const urlWithParams = `${msgAccesskey}msg-identifier=${identifier}&blip-identifier=${blipIdentifier}&blip-token=${blipToken}&email=${email}&issuer=${issuer}&fullName=${fullName}&tenantId=${tenantId}`;
        const encodedUrl = this.$base64.encode(urlWithParams);
        const debugUrl = this.TenantService.addTenantPrefixToUrl(this.DEBUG_URL_TENANT, tenantId, this.DEBUG_URL);
        const trackName = DEBUG_OPENED;
        this.SegmentService.createTrack(trackName, {
            botName: this.application.name,
            template: this.application.template,
        });
        window.open(debugUrl + '?' + encodedUrl, '_blank');
    }
    async refreshChat() {
        this.$cookies.remove(this.botTesterCookieKey);
        localStorage.removeItem('blipSdkUAccount');
        this.blipChatWidget.destroy();
        this.init(true);
        const trackName = DEBUG_REFRESH;
        this.SegmentService.createTrack(trackName, {
            botName: this.application.name,
            template: this.application.template,
        });
    }
    getUserTesterCookieID() {
        const userTesterID = this.$cookies.get(this.botTesterCookieKey);
        return userTesterID;
    }
    saveUserTesterCookie(userID) {
        this.$cookies.put(this.botTesterCookieKey, userID, {
            expires: new Date(moment(new Date())
                .add(3, 'day')
                .toDate()),
        });
    }
}
ChatbotTestController.$inject = ['application', 'ApplicationService2', 'SegmentService', 'UsersService', 'close', 'BLIPCHATURI', 'BLIPCHATURITENANT', 'ChatService', '$cookies', 'DEBUG_URL', 'DEBUG_URL_TENANT', '$base64', 'AccountService2', 'AuthenticationService', '$translate', 'ChatbotSettingsService', 'ngToast', 'BLIP_ACCOUNT_ISSUER', 'BLIP_AZURE_ISSUER', 'TenantService', 'typeOfCompile'];
